import Vue      from 'vue'
import VueMeta  from 'vue-meta'

Vue.use(VueMeta)

import App      from './App'
import router   from './router/router'
import store    from './store/store'

import { ButtonElements, svgs } from '@/helpers/buttons'

Vue.config.productionTip = false

Vue.component('PageMain', {
    props: {
        tag: {
            type: String,
            default: 'main'
        },
    },
    render(h) {
        return h(this.tag, {
            attrs: {
                id: 'main',
                tabindex: '-1',
            },
        }, this.$slots.default)
    }
})

Vue.component('Logo', {
    data() {
        return {
            win: require('@/assets/img/logo.png'),
            ret: require('@/assets/img/logo@2x.png')
        }
    },
    computed: {
        srcset() {
            return `${this.win} 1x, ${this.ret} 2x`
        }
    },
    render(h) {
        const { win: src, srcset } = this
        return h('a', {
            class: 'logo',
            attrs: {
                'aria-label': 'Doane Grant Thornton Website',
            },
            domProps: {
                href: 'https://doanegrantthornton.ca',
                rel: 'noopener',
                target: "_blank"
            },
        }, [
            h('img', {
                domProps: {
                    src,
                    srcset,
                    width: 274,
                    height: 80,
                    alt: ''
                }
            })
        ])
    }
})

Vue.component('SplashImage', {
    props: {
        count: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            path: require('@/assets/img/purple-splash.png'),
        }
    },
    render(h) {
        const splashImg = h('img', {
            class: 'slide__splash__img',
            domProps: {
                src: this.path,
                width: 520,
                height: 520,
                alt: ''
            }
        })

        return h('div', {
            class: 'slide__splash',
        }, Array.from({ length: this.count })
            .map(() => splashImg)
        )
    }
})

Vue.component('Copyright', {
    props: {
        links: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: 'privacy'
        },
    },
    computed: {
        innerHTML() {
            let html = `&copy; Copyright ${new Date().getFullYear()}, Doane Grant Thornton LLP Canada.`
            if ( this.links ) 
                return html + ` <a href="https://doanegrantthornton.ca/en/privacy-policy/" target="_blank" rel="noopener">Privacy Policy</a>. <a href="https://doanegrantthornton.ca/accessibility/" target="_blank" rel="noopener">Accessibility</a>.`
                return html
        },
    },
    render(h) {
        const { name, innerHTML } = this
        
        return h('footer', {
            class: name,
            domProps: { innerHTML }
        })
    }
})

const propsButton = {
    type: String,
    label: {
        type: [String, Boolean],
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
}

Vue.component('ArrowButton', {
    render(h) {
        const { tag, rel, ariaLabel } = this

        const elems = new ButtonElements(h, {
            html: this.svg,
        }, {
            html: this.text
        })

        return h(tag, {
            class: this.classes,
            attrs: {
                rel,
                'aria-label': ariaLabel,
            },
        }, [
            elems.BtnIcon, 
            elems.BtnText
        ])
    },
    props: {
        tag: {
            type: String,
            default: 'button'
        },
        color: Boolean,
        ...propsButton,
    },
    computed: {
        classes() {
            if ( this.color ) {
                return `link link--${this.type} link--purple`
            }
            else return ( this.type !== 'top' ) ? `link link--${this.type}` : `link link--top`
        },
        ariaLabel() {
            if ( this.label ) {
                return this.label
            }
            return undefined
        },
        rel() {
            if ( this.type )
                return this.type.includes('prev') || this.type.includes('next') ? this.type : null
                return null
        },
        svg() {
            if ( this.type )
                return svgs[this.type]
                return null
        }
    }
})

Vue.component('ButtonMore', {
    render(h) {
        const { href, rel, ariaLabel } = this

        const tag = this.href ? 'a' : 'button'

        const elems = new ButtonElements(h, {
            classes: 'more__icon',
            html: this.type ? this.svg : '<i />',
        }, {
            classes: `more__text`,
            html: this.innerText,
        })

        return h(tag, {
            class: this.classes,
            attrs: {
                href,
                rel,
                'aria-label': ariaLabel,
            },
        }, [
            elems.BtnIcon, 
            elems.BtnText
        ])
    },
    props: {
        names: String,
        href: String,
        ...propsButton,
    },
    methods: {
        hasIcon( type ) {
            const valid = ['top', 'prev', 'next', 'play']
            return valid.includes(type)
        },
    },
    computed: {
        innerText() {
            if ( this.type === 'play' ) {
                return 'Play video' 
            }
            return this.text
        },
        ariaLabel() {
            if ( this.label && this.type === 'play' ) {
                return this.label.replace('See more information', 'Play video')
            }
            if ( this.label || !this.type ) {
                return this.label
            }
            return undefined
        },
        classes() {
            const color = this.$store.getters.color
            let names = `more more--${color}`

            if ( this.hasIcon( this.type ) ) {
                names = ( this.type !== 'top' )
                        ? `more more--arrow more--${color}`
                        : `more more--arrow more--top more--${color}`
            }

            return names
        },
        rel() {
            if ( this.type )
                return this.type.includes('prev') || this.type.includes('next') ? this.type : null
                return null
        },
        svg() {
            if ( this.type )
                return svgs[this.type]
                return null
        }
    }
})

Vue.component('LinkButton', {
    template: `
        <a :href=href :rel="target && 'noopener'" :class="classes" :target="target" data-flex="center">
            <span v-html="text" />
            <span v-if="svg" v-html="svg" />
            <span class="arrow" v-else><i /></span>
        </a>
    `,
    props: {
        text: String,
        href: String,
        target: {
            type: String,
            default: '_blank'
        }
    },
    computed: {
        classes() {
            let names = `button button--purple button--social`
            return names
        },
        svg() {
            return svgs.next
        }
    }
})

Vue.mixin({
    methods: {
        isMobile() {
            return this.$store.getters['browser/isMobile']
        },
        rootClass( type, className ) {
            const html = document.querySelector('html')
            const name = className || 'no-overflow'

            switch( type ) {
                case 'add': if ( ! html.classList.contains(name) )
                            html.classList.add( name )
                            this.$root.$el.classList.add( name )
                            break
                default:    html.classList.remove( name )
                            this.$root.$el.classList.remove( name )
            }

        },
        mobileClass( type, className ) {
            if ( !this.isMobile() ) return; 
            
            this.rootClass(type, className)
        },
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#web')
